var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"video__container"}},[_c('video',{attrs:{"autoplay":"","muted":"","loop":"","id":"video"},domProps:{"muted":true}},[_c('source',{attrs:{"src":require("./../assets/media/video/test4.mp4"),"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }